export default __webpack_public_path__ + "static/media/LOGO_OXETECH_WORK_01-removebg-preview 3.4fdb3f41.png";